import { combineReducers } from 'redux';

import cePackReducer from '../components/CMS/SystemAdmin/CEPacks/reducer';
import seatWaitListReducer from '../components/CMS/SystemAdmin/TrainingProducts/TrainingProduct/WaitListLink/reducer';
import certificateReducer from '../components/CMS/SystemAdmin/Certificates/store/reducer';
import contentManagementReducer from '../components/CMS/SystemAdmin/ContentManagement/reducer';
import couponReducer from '../components/CMS/SystemAdmin/Coupons/reducer';
import designationElementReducer from '../components/CMS/SystemAdmin/DesignationElements/reducer';
import designationReportsReducer from '../components/CMS/SystemAdmin/DesignationReports/reducer';
import instructorReducer from '../components/CMS/SystemAdmin/Instructors/reducer';
import licenseeReducer from '../components/CMS/SystemAdmin/Licensees/reducer';
import orderIndividualReducer from '../components/CMS/SystemAdmin/Users/User/Purchases/store/reducers';
import orderReducer from '../components/CMS/SystemAdmin/Orders/reducer';
import organizationDetailReducer from '../components/CMS/SystemAdmin/Organizations/Organization/reducer';
import productAccessReducer from '../components/CMS/SystemAdmin/Users/User/ProductAccess/store/reducer';
import productDetailsReducer from '../components/CMS/SystemAdmin/TrainingProducts/TrainingProduct/ProductDetails/reducer';
import productEventsReducer from '../components/CMS/SystemAdmin/TrainingProducts/TrainingProduct/ProductEvent/store/reducers';
import productLinksReducer from '../components/CMS/SystemAdmin/TrainingProducts/TrainingProduct/ProductLink/reducer';
import productReducer from '../components/CMS/SystemAdmin/TrainingProducts/reducer';
import productTypeReducer from '../components/CMS/SystemAdmin/ProductTypes/store/reducer';
import questionReducer from '../components/CMS/SystemAdmin/Questions/reducer';
import sellingGroupCategoryReducer from '../components/CMS/SystemAdmin/SellingGroupCategories/reducer';
import sellingGroupReducer from '../components/CMS/SystemAdmin/SellingGroups/store/reducer';
import shipmentsReducer from '../components/CMS/SystemAdmin/Shipments/reducer';
import shippingReportsReducer from '../components/CMS/SystemAdmin/ShippingReports/reducer';
import surveyDetailsReducer from '../components/CMS/SystemAdmin/Surveys/Survey/reducer';
import surveyReducer from '../components/CMS/SystemAdmin/Surveys/reducer';
import surveyReportsReducer from '../components/CMS/SystemAdmin/SurveyReports/reducer';
import testDetailsReducer from '../components/CMS/SystemAdmin/Tests/Test/reducer';
import testReducer from '../components/CMS/SystemAdmin/Tests/reducer';
import userDetailsReducer from '../components/CMS/SystemAdmin/Users/User/reducer';
import userReducer from '../components/CMS/SystemAdmin/Users/reducer';
import bundledSeatsReducer from '../components/CMS/SystemAdmin/BundledSeats/store/reducer';

import { dataAddProductReducer } from '../components/CMS/SystemAdmin/GlobalStateReduce';

const adminReducer = combineReducers({
     cePacks: cePackReducer,
     certificates: certificateReducer,
     contentManagements: contentManagementReducer,
     coupons: couponReducer,
     dataAddProduct: dataAddProductReducer,
     designationElements: designationElementReducer,
     designationReports: designationReportsReducer,
     instructors: instructorReducer,
     licensees: licenseeReducer,
     orderIndividual: orderIndividualReducer,
     orders: orderReducer,
     organization: organizationDetailReducer,
     productAccess: productAccessReducer,
     productDetails: productDetailsReducer,
     productEvents: productEventsReducer,
     productLinks: productLinksReducer,
     products: productReducer,
     productTypes: productTypeReducer,
     question: questionReducer,
     sellingGroupCategories: sellingGroupCategoryReducer,
     sellingGroups: sellingGroupReducer,
     shipments: shipmentsReducer,
     shippingReports: shippingReportsReducer,
     surveyDetails: surveyDetailsReducer,
     surveyReports: surveyReportsReducer,
     surveys: surveyReducer,
     testDetails: testDetailsReducer,
     tests: testReducer,
     userDetails: userDetailsReducer,
     users: userReducer,
     seatWaitList: seatWaitListReducer,
     bundledSeats: bundledSeatsReducer,
});

export default adminReducer;
